export default __webpack_public_path__ + "static/media/test.15ac0c94.gif";